var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownQr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 15.8231C16.632 15.8231 15.4264 16.496 14.6692 17.5195L8.12262 14.1673C8.23131 13.7968 8.30769 13.4128 8.30769 13.0077C8.30769 12.4582 8.19503 11.9358 8.0004 11.4553L14.8517 7.33243C15.6142 8.22726 16.7349 8.80769 18 8.80769C20.2906 8.80769 22.1538 6.94442 22.1538 4.65385C22.1538 2.36328 20.2906 0.5 18 0.5C15.7094 0.5 13.8462 2.36328 13.8462 4.65385C13.8462 5.18171 13.9548 5.68243 14.1352 6.14729L7.26346 10.2822C6.50165 9.41397 5.39709 8.85385 4.15385 8.85385C1.86328 8.85385 0 10.7171 0 13.0077C0 15.2983 1.86328 17.1615 4.15385 17.1615C5.54446 17.1615 6.77035 16.4688 7.52469 15.4166L14.0497 18.758C13.9296 19.1459 13.8462 19.55 13.8462 19.9769C13.8462 22.2675 15.7094 24.1308 18 24.1308C20.2906 24.1308 22.1538 22.2675 22.1538 19.9769C22.1538 17.6864 20.2906 15.8231 18 15.8231Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownQr);
export default __webpack_public_path__ + "static/media/DownQR.59f1a6218a5008e187ffc0f083944fde.svg";
export { ForwardRef as ReactComponent };